import { NewsletterBlock } from "@/components/public/NewsletterBlock";

export default function NewsletterPage() {
  return (
    <div className="max-w-[900px] mx-auto px-4 sm:px-6 py-16">
      <div className="text-center">
        <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-crimson">Newsletter</div>
        <h1 className="font-serif font-bold text-4xl sm:text-6xl text-ink mt-2">The Fin Desk Daily</h1>
        <p className="text-lg text-ink2 mt-4 max-w-xl mx-auto leading-relaxed">The essential developments across fintech, payments and modern finance — delivered to your inbox.</p>
      </div>
      <div className="mt-10 border border-hair p-2"><NewsletterBlock compact /></div>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
        {[["Curated","Only what genuinely matters across the sector."],["Primary sources","Reporting grounded in official announcements and filings."],["European focus","A strong European lens on global developments."]].map(([t,d]) => (
          <div key={t} className="border-t-2 border-ink pt-4"><div className="font-serif text-xl text-ink">{t}</div><p className="text-sm text-ink2 mt-1">{d}</p></div>
        ))}
      </div>
    </div>
  );
}
